"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var CancelOrder = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M16.5480536,11.0127077 L16.0016796,8.00213623 L6.99759022,7.99761963 L4.99798694,19.0016327 L12.9989177,19.0022771 L12.9989177,20.0052035 L5.00627247,19.9992828 C4.45398772,19.9992828 4,19.555584 4,19.0032992 C4,18.9693607 4.66662634,15.301401 5.99987903,7.99942017 C6.07493006,7.51158848 6.49503171,7.00166321 6.98860279,7.00166321 L7.99891773,7 L7.99891773,6 C7.99891773,4.34314575 9.56592111,3 11.4989177,3 C13.4319144,3 14.9989177,4.34314575 14.9989177,6 L15.0011714,7 L16.0098278,6.99664307 C16.4941875,6.99655151 16.9183735,7.51608982 16.9934246,8.00392151 L17.5400209,11.0133206 L16.5480536,11.0127077 Z M9.00117136,7 L13.9989177,7 L13.9989177,6 C13.9989177,4.93258279 12.9109045,4 11.4989177,4 C10.086931,4 8.99891773,4.93258279 8.99891773,6 L9.00117136,7 Z M18.4958053,15.7914631 L21.1391395,13.1464466 C21.3344017,12.9511845 21.6509842,12.9511845 21.8462463,13.1464466 C22.0415084,13.3417088 22.0415084,13.6582912 21.8462463,13.8535534 L19.2026872,16.4987949 L21.8462463,19.1440365 C22.0415084,19.3392986 22.0415084,19.6558811 21.8462463,19.8511433 C21.6509842,20.0464054 21.3344017,20.0464054 21.1391395,19.8511433 L18.4958053,17.2061267 L15.8524711,19.8511433 C15.657209,20.0464054 15.3406265,20.0464054 15.1453643,19.8511433 C14.9501022,19.6558811 14.9501022,19.3392986 15.1453643,19.1440365 L17.7889234,16.4987949 L15.1453643,13.8535534 C14.9501022,13.6582912 14.9501022,13.3417088 15.1453643,13.1464466 C15.3406265,12.9511845 15.657209,12.9511845 15.8524711,13.1464466 L18.4958053,15.7914631 Z" })));
};
CancelOrder.displayName = 'CancelOrder';
exports.default = CancelOrder;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=CancelOrder.js.map